module.exports = __webpack_public_path__ + "img/Kerze_Gold.7a0619e6.png";